import { render, staticRenderFns } from "./welcome_editor.vue?vue&type=template&id=08149e00&scoped=true&"
import script from "./welcome_editor.vue?vue&type=script&lang=js&"
export * from "./welcome_editor.vue?vue&type=script&lang=js&"
import style0 from "./welcome_editor.vue?vue&type=style&index=0&id=08149e00&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08149e00",
  null
  
)

export default component.exports